<template>
  <div class="detail-content">
    <el-tabs v-model="activeName" type="card">
      <el-tab-pane label="人员详情" name="detailInfo">
        <detail-header :detailsObj="accountResumeData" />
        <div class="basic-info">
          <h3>基本信息</h3>
          <el-form
            ref="baseFormRef"
            :rules="baseRules"
            size="mini"
            :inline="true"
            :model="accountResumeData"
          >
            <el-form-item label="性别：" prop="sex">
              <el-radio-group
                v-model="accountResumeData.sex"
                :disabled="isSexDisabled"
                size="small"
              >
                <el-radio
                  v-for="(item, index) in sexList"
                  :key="index"
                  :label="item.value"
                  >{{ item.label }}</el-radio
                >
              </el-radio-group>
            </el-form-item>
            <el-form-item label="出生日期：" prop="birthday">
              <el-date-picker
                style="width: 125px"
                v-model="accountResumeData.birthday"
                type="date"
                value-format="yyyy-MM-dd"
                :disabled="notEditable"
                placeholder="选择日期"
              >
              </el-date-picker>
            </el-form-item>
            <el-form-item label="年龄：">
              {{ getAge(accountResumeData.birthday) }}
            </el-form-item>
            <el-form-item label="民族：" prop="nationality">
              <el-select
                style="width: 75px"
                v-model="accountResumeData.nationality"
                :disabled="notEditable"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in nationList"
                  :key="item.value"
                  :label="item.text"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="婚姻状态：" prop="marriage">
              <el-select
                style="width: 75px"
                v-model="accountResumeData.marriage"
                :disabled="notEditable"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in maritalStatusList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="籍贯：" prop="nativePlace">
              <el-cascader
                v-model="accountResumeData.nativePlace"
                :disabled="notEditable"
                :options="cityList"
                style="width: 200px; margin-right: 10px"
              />
            </el-form-item>
            <el-form-item label="现居住地：" prop="liveGrounds">
              <el-cascader
                v-model="accountResumeData.liveGrounds"
                :disabled="notEditable"
                :options="cityList"
              />
            </el-form-item>
            <el-form-item label-width="0px" prop="liveAddress">
              <el-input
                v-model="accountResumeData.liveAddress"
                :disabled="notEditable"
                placeholder="请输入详细地址（含门牌号）"
                style="width: 250px; margin-left: 10px"
              />
            </el-form-item>
            <el-form-item label="户口所在地：" prop="permanentResidence">
              <el-cascader
                v-model="accountResumeData.permanentResidence"
                :disabled="notEditable"
                :options="cityList"
              />
            </el-form-item>
            <br />
            <el-form-item label="家庭住址：" prop="familyAdress">
              <el-cascader
                v-model="accountResumeData.familyAdress"
                :disabled="notEditable"
                :options="cityList"
              />
            </el-form-item>
            <el-form-item label-width="0px" prop="address">
              <el-input
                v-model="accountResumeData.address"
                :disabled="notEditable"
                placeholder="请输入详细地址（含门牌号）"
                style="width: 250px; margin-left: 10px"
              />
            </el-form-item>
            <el-form-item label="电子邮件：" prop="email">
              <el-input
                v-model="accountResumeData.email"
                :disabled="notEditable"
                placeholder="请输入电子邮件"
              />
            </el-form-item>
            <el-form-item label="月收入愿望：" prop="expMonIncome">
              <el-input
                maxlength="10"
                v-model="accountResumeData.expMonIncome"
                :disabled="notEditable"
                placeholder="请输入"
                style="width: 100px; margin-right: 10px"
              />
              万元
            </el-form-item>
            <el-form-item label="现月均收入：" prop="monIncome">
              <el-input
                :maxlength="10"
                v-model="accountResumeData.monIncome"
                :disabled="notEditable"
                placeholder="请输入"
                style="width: 100px; margin-right: 10px"
              />
              万元
            </el-form-item>
            <el-form-item label="紧急联系人姓名：" prop="emergencyConName">
              <el-input
                v-model="accountResumeData.emergencyConName"
                :disabled="notEditable"
                maxlength="30"
                style="width: 125px"
                placeholder="请输入"
              />
            </el-form-item>
            <el-form-item label="紧急联系人电话：" prop="emergencyConTel">
              <el-input
                v-model="accountResumeData.emergencyConTel"
                :disabled="notEditable"
                maxlength="11"
                style="width: 125px"
                placeholder="请输入"
              />
            </el-form-item>
            <el-form-item label="预计最早上班时间：" prop="earliestWorkHour">
              <el-date-picker
                style="width: 125px"
                value-format="yyyy-MM-dd"
                v-model="accountResumeData.earliestWorkHour"
                type="date"
                :disabled="notEditable"
                placeholder="选择日期"
              >
              </el-date-picker>
            </el-form-item>
            <el-form-item label="招募来源：" prop="recruitSource">
              <el-select
                style="width: 75px"
                v-model="accountResumeData.recruitSource"
                :disabled="notEditable"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in recruitSourceList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-form>
        </div>
        <div class="work-history office-saff-table">
          <h3>工作经历</h3>
          <el-divider></el-divider>
          <el-table
            border
            :data="accountResumeData.works"
            style="width: 100%"
            :cell-style="tableCellStyle"
            :header-cell-style="tableHeaderColor"
            @row-dblclick="handleWorkRowDblClick"
          >
            <el-table-column align="center" type="index" label="序号" width="50" />

            <!-- 单位 -->
            <el-table-column align="center" prop="unit" label="单位">
              <template slot-scope="scope">
                <el-input
                  v-if="!notEditable && scope.row.isEditing"
                  v-model="scope.row.unit"
                  size="mini"
                  :maxlength="30"
                  placeholder="请输入"
                  @blur="saveWorkEdit(scope.row, 'unit', scope.$index)"
                  @keyup.enter.native="saveWorkEdit(scope.row, 'unit', scope.$index)"
                />
                <span v-else>{{ scope.row.unit }}</span>
              </template>
            </el-table-column>

            <!-- 部门 -->
            <el-table-column align="center" prop="dept" label="部门">
              <template slot-scope="scope">
                <el-input
                  v-if="!notEditable && scope.row.isEditing"
                  v-model="scope.row.dept"
                  size="mini"
                  :maxlength="30"
                  placeholder="请输入"
                  @blur="saveWorkEdit(scope.row, 'dept', scope.$index)"
                  @keyup.enter.native="saveWorkEdit(scope.row, 'dept', scope.$index)"
                />
                <span v-else>{{ scope.row.dept }}</span>
              </template>
            </el-table-column>

            <!-- 职位 -->
            <el-table-column align="center" prop="job" label="职位">
              <template slot-scope="scope">
                <el-input
                  v-if="!notEditable && scope.row.isEditing"
                  v-model="scope.row.job"
                  size="mini"
                  :maxlength="30"
                  placeholder="请输入"
                  @blur="saveWorkEdit(scope.row, 'job', scope.$index)"
                  @keyup.enter.native="saveWorkEdit(scope.row, 'job', scope.$index)"
                />
                <span v-else>{{ scope.row.job }}</span>
              </template>
            </el-table-column>

            <!-- 调动理由 -->
            <el-table-column align="center" prop="transReason" label="调动理由" width="180">
              <template slot-scope="scope">
                <el-input
                  v-if="!notEditable && scope.row.isEditing"
                  v-model="scope.row.transReason"
                  size="mini"
                  :maxlength="30"
                  placeholder="请输入"
                  @blur="saveWorkEdit(scope.row, 'transReason', scope.$index)"
                  @keyup.enter.native="saveWorkEdit(scope.row, 'transReason', scope.$index)"
                />
                <span v-else>{{ scope.row.transReason }}</span>
              </template>
            </el-table-column>

            <!-- 时间范围 -->
            <el-table-column align="center" prop="dateRange" label="时间范围" width="380">
              <template slot-scope="scope">
                <el-date-picker
                  v-if="!notEditable && scope.row.isEditing"
                  size="mini"
                  v-model="scope.row.dateRange"
                  type="monthrange"
                  format="yyyy-MM"
                  value-format="yyyy-MM"
                  range-separator="to"
                  start-placeholder="开始"
                  end-placeholder="截至"
                  :clearable="false"
                  @blur="saveWorkEdit(scope.row, 'dateRange', scope.$index)"
                  @keyup.enter.native="saveWorkEdit(scope.row, 'dateRange', scope.$index)"
                />
                <span v-else>{{ scope.row.beginDate }} to {{ scope.row.endDate }}</span>
              </template>
            </el-table-column>

            <!-- 证明人 -->
            <el-table-column align="center" prop="reterence" label="证明人" width="100">
              <template slot-scope="scope">
                <el-input
                  v-if="!notEditable && scope.row.isEditing"
                  v-model="scope.row.reterence"
                  size="mini"
                  maxlength="30"
                  placeholder="请输入"
                  @blur="saveWorkEdit(scope.row, 'reterence', scope.$index)"
                  @keyup.enter.native="saveWorkEdit(scope.row, 'reterence', scope.$index)"
                />
                <span v-else>{{ scope.row.reterence }}</span>
              </template>
            </el-table-column>

            <!-- 证明人联系电话 -->
            <el-table-column align="center" prop="tel" label="证明人联系电话" width="120">
              <template slot-scope="scope">
                <el-input
                  v-if="!notEditable && scope.row.isEditing"
                  v-model="scope.row.tel"
                  size="mini"
                  maxlength="11"
                  placeholder="请输入"
                  @blur="saveWorkEdit(scope.row, 'tel', scope.$index)"
                  @keyup.enter.native="saveWorkEdit(scope.row, 'tel', scope.$index)"
                />
                <span v-else>{{ scope.row.tel }}</span>
              </template>
            </el-table-column>

            <!-- 操作 -->
            <el-table-column v-if="states == 'edit'" label="操作" width="100">
              <template slot-scope="scope">
                <el-button @click="delWorkFunc(scope.$index)" type="text" size="small">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
          <div class="work-history-btn" v-if="states == 'edit'">
            <el-button type="primary" size="small" @click="addWork"
              >新增</el-button
            >
          </div>
        </div>
        <div class="learning-experience office-saff-table">
          <h3>学习经历</h3>
          <el-divider></el-divider>
          <el-table
            :data="accountResumeData.educations"
            border
            style="width: 100%"
            :cell-style="tableCellStyle"
            :header-cell-style="tableHeaderColor"
            @row-dblclick="handleLearingRowDblClick"
          >
            <el-table-column
              align="center"
              type="index"
              label="序号"
              width="50"
            />
            <el-table-column align="center" prop="school" label="学校">
              <template slot-scope="scope">
                <el-input
                  v-if="!notEditable && scope.row.isEditing"
                  v-model="scope.row.school"
                  size="mini"
                  maxlength="30"
                  placeholder="请输入"
                  @blur="saveLearningEdit(scope.row, 'school', scope.$index)"
                  @keyup.enter.native="saveLearningEdit(scope.row, 'school', scope.$index)"
                />
                <span v-else>{{ scope.row.school }}</span>
              </template>
            </el-table-column>
            <el-table-column align="center" prop="specialty" label="专业">
              <template slot-scope="scope">
                <el-input
                  v-if="!notEditable && scope.row.isEditing"
                  v-model="scope.row.specialty"
                  size="mini"
                  maxlength="30"
                  placeholder="请输入"
                  @blur="saveLearningEdit(scope.row, 'specialty', scope.$index)"
                  @keyup.enter.native="saveLearningEdit(scope.row, 'specialty', scope.$index)"
                />
                <span v-else>{{ scope.row.specialty }}</span>
              </template>
            </el-table-column>
            <el-table-column align="center" prop="series" label="系">
              <template slot-scope="scope">
                <el-input
                  v-if="!notEditable && scope.row.isEditing"
                  v-model="scope.row.series"
                  size="mini"
                  maxlength="30"
                  placeholder="请输入"
                  @blur="saveLearningEdit(scope.row, 'series', scope.$index)"
                  @keyup.enter.native="saveLearningEdit(scope.row, 'series', scope.$index)"
                />
                <span v-else>{{ scope.row.series }}</span>
              </template>
            </el-table-column>
            <el-table-column align="center" prop="degree" label="学历">
              <template slot-scope="scope">
                <el-select
                  v-if="!notEditable && scope.row.isEditing"
                  v-model="scope.row.degree"
                  size="mini"
                >
                  <el-option
                    v-for="item in degreeList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
                <span v-else>{{ scope.row.degree }}</span>
              </template>
            </el-table-column>
            <el-table-column
              align="center"
              prop="dateRange"
              label="时间范围"
              width="380"
            >
              <template slot-scope="scope">
                <el-date-picker
                  v-if="!notEditable && scope.row.isEditing"
                  size="mini"
                  v-model="scope.row.dateRange"
                  type="monthrange"
                  format="yyyy-MM"
                  value-format="yyyy-MM"
                  range-separator="to"
                  start-placeholder="开始"
                  end-placeholder="截至"
                  :clearable="false"
                  @blur="saveLearningEdit(scope.row, 'dateRange', scope.$index)"
                  @keyup.enter.native="saveLearningEdit(scope.row, 'dateRange', scope.$index)"
                ></el-date-picker>
                <span v-else
                  >{{ scope.row.beginDate }} to {{ scope.row.endDate }}</span
                >
              </template>
            </el-table-column>
            <el-table-column
              align="center"
              prop="specialtyBackground"
              label="专业背景"
            >
              <template slot-scope="scope">
                <el-select
                  v-if="!notEditable && scope.row.isEditing"
                  v-model="scope.row.specialtyBackground"
                  size="mini"
                >
                  <el-option
                    v-for="item in professionalBackgroundList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
                <span v-else>{{ scope.row.specialtyBackground }}</span>
              </template>
            </el-table-column>
            <el-table-column v-if="states == 'edit'" label="操作" width="100">
              <template slot-scope="scope">
                <!-- status -->
                <el-button
                  @click="delEducationFunc(scope.$index)"
                  type="text"
                  size="small"
                  >删除</el-button
                >
              </template>
            </el-table-column>
          </el-table>
          <div class="learning-experience-btn" v-if="states == 'edit'">
            <el-button type="primary" size="small" @click="addEducation()"
              >新增</el-button
            >
          </div>
        </div>
        <div class="family-members office-saff-table">
          <h3>家庭成员</h3>
          <el-divider></el-divider>
          <el-table
            border
            :data="accountResumeData.families"
            style="width: 100%"
            :cell-style="tableCellStyle"
            :header-cell-style="tableHeaderColor"
            @row-dblclick="handleFamilyRowDblClick"
          >
            <el-table-column
              align="center"
              type="index"
              label="序号"
              width="50"
            />
            <el-table-column align="center" prop="name" label="姓名">
              <template slot-scope="scope">
                <el-input
                  v-if="!notEditable && scope.row.isEditing"
                  v-model="scope.row.name"
                  size="mini"
                  maxlength="20"
                  placeholder="请输入"
                  clearable
                  @blur="saveFamilyEdit(scope.row, 'name', scope.$index)"
                  @keyup.enter.native="saveFamilyEdit(scope.row, 'name', scope.$index)"
                />
                <span v-else>{{ scope.row.name }}</span>
              </template>
            </el-table-column>
            <el-table-column align="center" prop="relationship" label="关系">
              <template slot-scope="scope">
                <template v-if="!notEditable && scope.row.isEditing">
                  <el-select v-model="scope.row.relationship" size="mini" @change="saveFamilyEdit(scope.row, 'relationship', scope.$index)">
                    <el-option
                      v-for="item in relationList"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </template>
                <span v-else>
                  {{ getRelationLabel(scope.row.relationship) }}
                </span>
              </template>
            </el-table-column>
            
            <el-table-column
              align="center"
              prop="relativesIdType"
              label="证件类型"
            >
              <template slot-scope="scope">
                <template v-if="!notEditable && scope.row.isEditing">
                  <!--  @change="validateID(scope.row)"  -->
                  <el-select v-model="scope.row.relativesIdType" size="mini" @change="saveFamilyEdit(scope.row, 'relativesIdType', scope.$index)">
                    <el-option
                      v-for="item in familyCardTypes"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </template>
                <span v-else>
                  {{ getFamilyCardTypeLabel(scope.row.relativesIdType) }}
                </span>
              </template>
            </el-table-column>
            <el-table-column
              align="center"
              prop="relativesIdNo"
              label="证件号码"
              width="260"
              placeholder="请输入"
            >
              <template slot-scope="scope">
                <template v-if="!notEditable && scope.row.isEditing">
                  <el-input
                    v-model="scope.row.relativesIdNo"
                    size="mini"
                    @blur="saveFamilyEdit(scope.row, 'relativesIdNo', scope.$index)"
                    @keyup.enter.native="
                      saveFamilyEdit(scope.row, 'relativesIdNo', scope.$index)
                    "
                  />
                  <div v-if="scope.row.errorMessage" class="error-text">
                    {{ scope.row.errorMessage }}
                  </div>
                </template>
                <span v-else>{{ scope.row.relativesIdNo }}</span>
              </template>
            </el-table-column>
            <el-table-column align="center" prop="relativesSex" label="性别" width="80">
              <template slot-scope="scope">
                <template v-if="!notEditable && scope.row.isEditing">
                  <!--  @change="validateID(scope.row)"  -->
                  <el-select v-model="scope.row.relativesSex" size="mini" @change="saveFamilyEdit(scope.row, 'relativesSex', scope.$index)">
                    <el-option
                      v-for="item in sexList"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </template>
                <span v-else>
                  {{ getFamilySexLabel(scope.row.relativesSex) }}
                </span>
              </template>
            </el-table-column>
            <el-table-column
              align="center"
              prop="relativesBirthday"
              label="出生日期"
              width="160"
            >
              <template slot-scope="scope">
                <el-date-picker
                  v-if="!notEditable && scope.row.isEditing"
                  v-model="scope.row.relativesBirthday"
                  type="date"
                  size="mini"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd"
                  :clearable="false"
                  placeholder="选择日期"
                >
                </el-date-picker>
                <span v-else>{{ scope.row.relativesBirthday }}</span>
              </template>
            </el-table-column>
            <el-table-column align="center" prop="unit" label="工作单位/学校">
              <template slot-scope="scope">
                <el-input
                  v-if="!notEditable && scope.row.isEditing"
                  v-model="scope.row.unit"
                  size="mini"
                  placeholder="请输入"
                  maxlength="30"
                  @blur="saveFamilyEdit(scope.row, 'unit', scope.$index)"
                  @keyup.enter.native="saveFamilyEdit(scope.row, 'unit', scope.$index)"
                />
                <span v-else>{{ scope.row.unit }}</span>
              </template>
            </el-table-column>
            <el-table-column align="center" prop="profession" label="职位">
              <template slot-scope="scope">
                <el-input
                  v-if="!notEditable && scope.row.isEditing"
                  v-model="scope.row.profession"
                  size="mini"
                  placeholder="请输入"
                  @blur="saveFamilyEdit(scope.row, 'profession', scope.$index)"
                  @keyup.enter.native="saveFamilyEdit(scope.row, 'profession', scope.$index)"
                />
                <span v-else>{{ scope.row.profession }}</span>
              </template>
            </el-table-column>
            <el-table-column v-if="states == 'edit'" label="操作" width="100">
              <template slot-scope="scope">
                <el-button
                  @click="delFamilyMembersFunc(scope.$index)"
                  type="text"
                  size="small"
                  >删除</el-button
                >
              </template>
            </el-table-column>
          </el-table>
          <div class="family-members-btn" v-if="states == 'edit'">
            <el-button type="primary" size="small" @click="addFamily()"
              >新增</el-button
            >
          </div>
        </div>
        <div class="other-info office-saff-table">
          <h3>其他信息</h3>
          <el-divider></el-divider>
          <el-form
            label-position="left"
            :model="accountResumeData.accountOther"
            label-width="400px"
          >
            <el-form-item label="是否在本地有两年以上的工作、学习或生活经历">
              <el-switch
                v-model="accountResumeData.accountOther.ques1"
                active-value="1"
                inactive-value="0"
                :disabled="notEditable"
              ></el-switch>
            </el-form-item>
            <el-form-item label="是否从事过人寿保险相关工作？如果有请简要说明">
              <el-switch
                v-model="accountResumeData.accountOther.ques2"
                active-value="1"
                inactive-value="0"
                :disabled="notEditable"
              ></el-switch>
            </el-form-item>
            <el-form-item
              label-width="0"
              v-if="accountResumeData.accountOther.ques2 == '1'"
            >
              <el-input
                style="width: 500px"
                type="textarea"
                :rows="3"
                maxlength="50"
                placeholder="请输入内容"
                v-model="accountResumeData.accountOther.ques2Desc"
              >
              </el-input>
            </el-form-item>
            <el-form-item label="您身体是否有任何残疾？">
              <el-switch
                v-model="accountResumeData.accountOther.ques3"
                active-value="1"
                inactive-value="0"
                :disabled="notEditable"
              ></el-switch>
            </el-form-item>
            <el-form-item label="若是女士，现在是否怀孕？">
              <el-switch
                v-model="accountResumeData.accountOther.ques4"
                active-value="1"
                inactive-value="0"
                :disabled="notEditable"
              ></el-switch>
            </el-form-item>
            <el-form-item label="您是否曾被逮捕，或触犯法律？">
              <el-switch
                v-model="accountResumeData.accountOther.ques5"
                active-value="1"
                inactive-value="0"
                :disabled="notEditable"
              ></el-switch>
            </el-form-item>
            <el-form-item label="您是否被前任雇主辞退过？">
              <el-switch
                v-model="accountResumeData.accountOther.ques6"
                active-value="1"
                inactive-value="0"
                :disabled="notEditable"
              ></el-switch>
            </el-form-item>
            <el-form-item label="您是否认识我们公司的员工？">
              <el-switch
                v-model="accountResumeData.accountOther.ques7"
                active-value="1"
                inactive-value="0"
                :disabled="notEditable"
              ></el-switch>
            </el-form-item>
          </el-form>
        </div>
        <div class="upload-form">
          <el-form
            ref="uploadForm"
            :model="accountResumeData"
            label-width="100px"
            label-position="left"
          >
            <el-row style="display: flex">
              <!-- <el-col :span="3">
                <el-form-item label="证件照片" prop="IdPhotoFront">
                  <imageUploader 
                    :imageUrl="accountResumeData.idPhotoFront"
                    :imageUrls="accountResumeData.idPhotoFronts"
                    :isViewMode="notEditable"
                    :idField="'certificateFrontPhotoFileId'"
                    :urlField="'IdPhotoFront'"
                    image-fit="cover"
                    image-width="100%"
                    image-height="100%"
                    @success="handleSuccess"
                    @remove="handleRemove"
                  >
                  </imageUploader>
                </el-form-item> 
              </el-col>
              <el-col :span="3">
                <el-form-item prop="IdPhotoBack">
                  <imageUploader 
                    :imageUrl="accountResumeData.idPhotoBack"
                    :imageUrls="accountResumeData.idPhotoBacks"
                    :isViewMode="notEditable"
                    :idField="'certificateBackPhotoFileId'"
                    :urlField="'IdPhotoBack'"
                    image-fit="cover"
                    image-width="100%"
                    image-height="100%"
                    @success="handleSuccess"
                    @remove="handleRemove"
                  >
                  </imageUploader>
                </el-form-item>
              </el-col> -->
              <el-col style="margin-right: 10px; width: 150px">
                <el-form-item label="证件照片" prop="IdPhotoFront">
                  <imageUploader
                    :imageUrl="accountResumeData.idPhotoFront"
                    :isViewMode="!notEditable"
                    :idField="'certificateFrontPhotoFileId'"
                    :urlField="['IdPhotoFront', 'certificateFrontPhotoFileId']"
                    image-fit="cover"
                    image-width="100%"
                    image-height="100%"
                    @success="handleSuccess"
                    @remove="handleRemove"
                  >
                  </imageUploader>
                </el-form-item>
              </el-col>
              <el-col>
                <el-form-item prop="IdPhotoBack">
                  <imageUploader
                    :imageUrl="accountResumeData.idPhotoBack"
                    :isViewMode="!notEditable"
                    :idField="'certificateBackPhotoFileId'"
                    :urlField="['IdPhotoBack', 'certificateBackPhotoFileId']"
                    image-fit="cover"
                    image-width="100%"
                    image-height="100%"
                    @success="handleSuccess"
                    @remove="handleRemove"
                  >
                  </imageUploader>
                </el-form-item>
              </el-col>
            </el-row>
            <el-form-item label="学历照片" prop="educationPhotoUrl">
              <imageUploader
                :imageUrl="accountResumeData.educationPhotoUrl"
                :imageUrls="accountResumeData.educationPhotoUrls"
                :isViewMode="!notEditable"
                :idField="'educationPhotoFileId'"
                :urlField="['educationPhotoUrl', 'educationPhotoFileId']"
                image-fit="cover"
                image-width="100%"
                image-height="100%"
                @success="handleSuccess"
                @remove="handleRemove"
              >
              </imageUploader>
            </el-form-item>
            <el-form-item label="学位证书" prop="degreePhotoUrl">
              <imageUploader
                :imageUrl="accountResumeData.degreePhotoUrl"
                :imageUrls="accountResumeData.degreePhotoUrls"
                :isViewMode="!notEditable"
                :idField="'degreePhotoFileId'"
                :urlField="['degreePhotoUrl', 'degreePhotoFileId']"
                image-fit="cover"
                image-width="100%"
                image-height="100%"
                @success="handleSuccess"
                @remove="handleRemove"
              >
              </imageUploader>
            </el-form-item>
            <el-form-item label="面试影像">
              <photo-wall-upload
                :initial-photos="fileListInterview"
                :editable="!notEditable"
                @change="handlePhotoChange"
              />
            </el-form-item>
          </el-form>
          <el-dialog
            :visible.sync="peviewVisible"
            :close-on-click-modal="false"
            :close-on-press-escape="false"
          >
            <img width="100%" :src="peviewImageUrl" alt="预览图片" />
          </el-dialog>
        </div>
        <div style="margin-left: 100px" v-if="!notEditable">
          <div>
            <div class="float-btn" @click="saveFunc()">
              <div>保存</div>
            </div>
          </div>
          <!-- <el-button type="primary" @click="saveFunc()">保存</el-button> -->
        </div>
      </el-tab-pane>
      <el-tab-pane label="修改记录" name="modify">
        <detail-header :detailsObj="accountResumeData" />
        <el-table
          :data="modifyRecondData"
          border
          :cell-style="tableCellStyle"
          :header-cell-style="tableHeaderColor"
          style="width: 642px"
        >
          <el-table-column
            align="center"
            type="index"
            label="序号"
            width="50"
          />
          <el-table-column
            align="center"
            prop="operationType"
            width="120"
            label="操作类型"
          />
          <el-table-column
            align="center"
            prop="createDate"
            width="180"
            label="操作时间"
          />
          <el-table-column
            align="center"
            prop="operationPlatform"
            width="120"
            label="操作平台"
          />
          <el-table-column
            align="center"
            prop="operatorName"
            width="120"
            label="操作人员"
          />
        </el-table>
      </el-tab-pane>
      <el-tab-pane label="招募流程记录" name="process">
        <detail-header :detailsObj="accountResumeData" />
        <el-timeline>
          <el-timeline-item
            class="custom-timeline-item"
            v-for="(record, index) in processRecords.lifeNodeList"
            :key="index"
            color="#409EFF"
          >
            <ul class="process-record">
              <li>环节： {{ record.nodeName }}</li>
              <li v-if="record.interviewer">面试官： {{ record.interviewer }}</li>
              <li v-if="record.result && record.result != '-1'">结果： {{ record.resultDesc }}</li>
              <li v-if="record.reason">原因： {{ record.reason }}</li>
              <li v-if="record.interviewerComment && record.result != '-1'"><span class="interview-comment-label">面试评语：</span> {{ record.interviewerComment }}</li>
              <li>操作人员： {{ record.transactor }}</li>
              <li>操作时间： {{ record.handlingTime }}</li>
            </ul>
          </el-timeline-item>
        </el-timeline>
      </el-tab-pane>
    </el-tabs>
    <div class="backBtn">
      <span style="margin-right:10px" v-if="
        (currentRouteType == '2' && accountData.lifeNode == '11') ||
        (currentRouteType == '3' && accountData.lifeNode == '13')
        ">
      <el-button
        type="success" size="small"
        @click="operateSingleFunc(accountData, 'sure')"
        >{{ currentRouteType == "2" ? "确认" : "通过" }}</el-button
      >
      <el-button size="small"
        type="danger"
        @click="operateSingleFunc(accountData, 'return')"
        >退回</el-button
      >
      </span>
      <el-button type="primary" size="small"  @click="backFunc"
        >返回</el-button
      >
    </div>    
  </div>
</template>
<script>
import url from "@/modules/url";
import api from "@/modules/api";
import cityData from "@/assets/js/city-data";
import nationalityList from "@/assets/js/nationality";
import { Options } from "@/components/utils/fixOptions";
import { getAgeViaStr } from "@/components/utils/dateUtil";
import detailHeader from "./component/detailHeader.vue";
import { ERR } from "./js/errCode";
import tableBaseCss from "../tableBaseCss";
import ValidateUtility from "./js/validator";
import base from "./js/base";
import imageUploader from "./component/imageUploader.vue";
import photoWallUpload from "./component/photoWallUpload.vue";

export default {
  mixins: [base, tableBaseCss],
  components: { detailHeader, imageUploader, photoWallUpload },
  props: {
    accountData: {
      type: Object,
      default: {},
    },
    states: {
      type: String,
      default: "view",
    },
    tab: {
      type: Number,
      default: 0,
    },
    currentRouteType: {
      type: String,
      default: "",
    },
  },
  computed: {
    isSexDisabled() {
      return this.notEditable || this.accountResumeData.certiType === '01';
    }
  },
  watch: {
    activeName: {
      handler(newVal, oldVal) {
        if (newVal == "process") {
          this.getProcessList();
        } else if (newVal == "modify") {
          this.getAccountHistoryList();
        } else {
          this.getDetail();
        }
      },
    },
  },
  data() {
    const checkEmail = (rule, value, callback) => {
      const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
      if (!emailRegex.test(value)) {
        callback(new Error(ERR.IE1005));
      } else {
        callback();
      }
    };

    const checkContact = (rule, value, callback) => {
      if (!/^[\u4e00-\u9fa5]+$/.test(value)) {
        callback(new Error(ERR.IE1006));
      } else {
        callback();
      }
    };
    const checkMobilePhone = (rule, value, callback) => {
      const phoneRegex = /^1[3-9]\d{9}$/;
      if (!phoneRegex.test(value)) {
        callback(new Error("请输入正确的手机号格式"));
      } else {
        callback();
      }
    };

    const checkName = (rule, value, callback) => {
      if (!/^[a-zA-Z\u4e00-\u9fa5]+$/.test(value)) {
        callback(new Error(ERR.IE1001));
      } else {
        callback();
      }
    };
    const checkInteger = (rule, value, callback) => {
      if (!/^\d+$/.test(value)) {
        callback(new Error("只能输入整数"));
      } else {
        callback();
      }
    };
    return {
      uploadRules: {
        IdPhotoFront: [
          { required: true, message: "请上传证件照正面", trigger: "change" },
        ],
        IdPhotoBack: [
          { required: true, message: "请上传证件照反面", trigger: "change" },
        ],
        educationPhotoUrl: [
          { required: true, message: "请上传学历照片", trigger: "change" },
        ],
        degreePhotoUrl: [
          { required: true, message: "请上传学位证书", trigger: "change" },
        ],
      },
      baseRules: {
        sex: [{ required: true, message: "请选择性别", trigger: "change" }],
        birthday: [
          { required: true, message: "请选择出生日期", trigger: "change" },
        ],
        nationality: [
          { required: true, message: "请选择民族", trigger: "change" },
        ],
        marriage: [
          { required: true, message: "请选择婚姻状态", trigger: "change" },
        ],
        nativePlace: [
          { 
            required: true, 
            message: "请选择籍贯", 
            trigger: ["change", "blur"],
            validator: (rule, value, callback) => {
              let _value = this.isEmpty(value);
              if (_value) {
                callback(new Error("请选择籍贯"));
              } else {
                callback();
              }
            }
          },
        ],
        permanentResidence: [
          { 
            required: true, 
            message: "请选择户口所在地", 
            trigger: ["change", "blur"],
            validator: (rule, value, callback) => {
              let _value = this.isEmpty(value);
              if (_value) {
                callback(new Error("请选择户口所在地"));
              } else {
                callback();
              }
            }
          },
        ],
        liveGrounds: [
          { 
            required: true, 
            message: "请选择现居住地", 
            trigger: ["change", "blur"],
            validator: (rule, value, callback) => {
              let _value = this.isEmpty(value);
              if (_value) {
                callback(new Error("请选择现居住地"));
              } else {
                callback();
              }
            }
          },
        ],
        liveAddress: [
          {
            required: true,
            message: "请输入详细地址（含门牌号）",
            trigger: "blur",
          },
          {
            pattern: /^(?=.*\d).{5,35}$/,
            message: "详细地址长度限制为5-35位，必须包含数字",
            trigger: "blur",
          },
        ],
        familyAdress: [
          { 
            required: true, 
            message: "请选择家庭住址", 
            trigger: ["change", "blur"],
            validator: (rule, value, callback) => {
              let _value = this.isEmpty(value);
              if (_value) {
                callback(new Error("请选择家庭住址"));
              } else {
                callback();
              }
            }
          },
        ],
        address: [
          {
            required: true,
            message: "请输入详细地址（含门牌号）",
            trigger: "blur",
          },
          {
            pattern: /^(?=.*\d).{5,35}$/,
            message: "详细地址长度限制为5-35位，必须包含数字",
            trigger: "blur",
          },
        ],
        email: [
          { required: true, message: "请输入邮箱", trigger: "blur" },
          { validator: checkEmail, trigger: "blur" },
        ],
        expMonIncome: [{ required: false }],
        monIncome: [{ required: false }],
        emergencyConName: [
          { required: true, message: "请输入紧急联系人姓名", trigger: "blur" },
          { validator: checkName, trigger: "blur" },
        ],
        emergencyConTel: [
          { required: true, message: "请输入紧急联系人电话", trigger: "blur" },
          { validator: checkMobilePhone, trigger: "blur" },
        ],
        earliestWorkHour: [
          { required: true, message: "请输入最早上班时间", trigger: "change" },
          // { validator: checkContact, trigger: "blur" },
        ],
      },
      accountResumeData: {
        sex: "",
        birthday: "",
        nationality: "",
        marriage: "",
        nativePlace: [],
        permanentResidence: [],
        liveGrounds: [],
        liveAddress: "",
        familyAdress: [],
        address: "",
        email: "",
        expMonIncome: null,
        monIncome: null,
        emergencyConName: "",
        emergencyConTel: "",
        earliestWorkHour: "",
        accountOther: {
          ques1: "",
          ques2: "",
          ques3: "",
          ques4: "",
          ques5: "",
          ques6: "",
          ques7: "",
        },
        idPhotoFront: "",
        idPhotoBack: "",
        educationPhotoUrl: "",
        degreePhotoUrl: "",
        interviewImageFileIds: [],
      }, // 详情数据
      basicInfoRules: [],
      notEditable: false, // 查看修改表示false 可修改 true 不可修改
      fileUrl: "", // 上传地址
      peviewVisible: false, // 预览图片标识
      peviewImageUrl: "", // 预览图片地址
      activeName: this.tab === 2 ? "process" : "detailInfo", // tab页表示
      cityList: cityData.newCityInfo,
      maritalStatusList: Options.marital_status,
      recruitSourceList: Options.recruit_source,
      nationList: nationalityList.nationalityList[0].values,
      sexList: Options.familySex,
      cardTypes: Options.id_type,
      familyCardTypes: Options.family_Card_type,
      relationList: Options.family_relation,
      degreeList: Options.degree_type,
      professionalBackgroundList: Options.professionalBackground,
      modifyRecondData: [],
      processRecords: [
        {
          nodeName: "分公司审核",
          result: "通过",
          transactor: "李默",
          handlingTime: "2024-10-14 13: 32:34",
        },
        {
          nodeName: "机构负责人确认",
          result: "确认",
          transactor: "李默",
          handlingTime: "2024-10-14 13: 32: 34",
        },
        {
          nodeName: "机构负责人确认",
          result: "退回",
          reason: "缺少信息操作人员",
          transactor: "李默",
          handlingTime: "2024-10-14 13:32:34",
        },
        {
          nodeName: "一面",
          result: "通过",
          transactor: "李默",
          handlingTime: "2024-10-14 13: 32: 34",
        },
        {
          nodeName: "简历完成",
          transactor: "李晓红",
          handlingTime: "2024-10-12 15:10:50",
        },
        {
          nodeName: "创建简历",
          transactor: "李莉莉",
          handlingTime: "2024-10-12 13:10:50",
        },
      ],
      dialogImageUrl: "", // 预览图片URL
      dialogVisible: false, // 预览对话框显示状态
      isUploading: false, // 上传状态标志
      fileListInterview: [], // 面试照片列表
    };
  },
  methods: {
    // 判断是否为空;
    isEmpty(value) {
      if (value.length) {
        let _empty = true;
        for (let i = 0; i < value.length; i++) {
          if (value[i]) _empty = false;
        }
        return _empty;
      }
    },
    operateSingleFunc(rowData, btnType){
      this.$emit('operateSingleFunc', rowData, btnType)
    },
    // 获取关系label
    getRelationLabel(relationship) {
      const item = this.relationList.find(ite => ite.value == relationship);
      return item ? item.label : '';
    },
    // 获取证件类型label
    getFamilyCardTypeLabel(cardType) {
      const item = this.familyCardTypes.find(ite => ite.value === cardType);
      return item ? item.label : '';
    },
    // 获取性别label
    getFamilySexLabel(sexCode) {
      const item = this.sexList.find(ite => ite.value === sexCode);
      return item ? item.label : '';
    },
    // 面试影像处理
    handlePhotoChange(val) {
      console.log(val, "-------handlePhotoChange");
      if (val && val.length) {
        this.accountResumeData.interviewImageFileIds = val.map(
          (item) => item.name
        );
      } else {
        this.accountResumeData.interviewImageFileIds = [];
      }
      console.log(
        this.accountResumeData.interviewImageFileIds,
        "------最终图片数组"
      );
    },
    getAccountHistoryList() {
      api.post(
        url.getAccountHistoryList,
        { userId: this.accountData.userId },
        (res) => {
          if (res.result.isSuccess) {
            this.modifyRecondData = res.data;
          } else {
            this.$message({
              type: "error",
              message: res.result.error,
            });
          }
        }
      );
    },
    getProcessList() {
      api.post(
        url.getRecruitFlowList,
        { userId: this.accountData.userId },
        (res) => {
          if (res.result.isSuccess) {
            console.log(res.data, "getRecruitFlowList===============");
            this.processRecords = res.data;
          } else {
            this.$message({
              type: "error",
              message: res.result.error,
            });
          }
        }
      );
    },
    getDetail() {
      // desensitization 是否脱敏
      api.post(url.getAccountResume, { id: this.accountData.userId,desensitization: this.notEditable }, (res) => {
        if (res.result.isSuccess) {
          let resData = JSON.parse(JSON.stringify(res.data));
          if (!resData.accountOther) {
            resData.accountOther = {
              ques1: "",
              ques2: "",
              ques3: "",
              ques4: "",
              ques5: "",
              ques6: "",
              ques7: "",
            };
          }
          this.accountResumeData = resData;
          // 如果 earliestWorkHour 不是一个有效的日期"2025-05-16"，清空这个值
          if (this.accountResumeData) {
          const date = this.accountResumeData.earliestWorkHour;
          if (isNaN(new Date(date))) {
            this.accountResumeData.earliestWorkHour = '';
          }
        }

          this.setDetailDataInPage(this.accountResumeData);
          this.show = false;
        } else {
          if (res.result.errors.length > 0) {
            this.$message({
              type: "error",
              message:
                res.result.errors[0].errorCode + res.result.errors[0].error,
            });
          } else {
            this.$message({
              type: "error",
              message: res.result.error,
            });
          }
        }
      });
    },
    // 根据出生日期得到年龄
    getAge(data) {
      return getAgeViaStr(data);
    },
    // 预览图片
    handlePictureCardPreview(file) {
      if (typeof file === "string") {
        this.peviewImageUrl = file;
      } else {
        this.peviewImageUrl = file.url;
      }
      this.peviewVisible = true;
    },
    deleteImage(url, filed) {
      this.accountResumeData[url] = "";
      this.accountResumeData[filed] = "";
    },
    // 删除文件
    handleRemove(key) {
      if (key.includes("interviewImageFileId")) {
        this.accountResumeData.interviewImageFileIds.splice(
          this.accountResumeData.interviewImageFileIds.indexOf(url),
          1
        );
      } else {
        // key为数组，如何将key中每一项置空
        key.forEach((item) => {
          this.accountResumeData[item] = "";
        });
        // this.accountResumeData[key] = "";
      }
    },
    // 文件上传成功后处理（存入对应字段）
    handleSuccess(fileId, fileUrl, field, name) {
      if (field === "interviewImageFileId") {
        if (!this.accountResumeData.interviewImageFileIds) {
          this.accountResumeData.interviewImageFileIds = [];
        }
        console.log(fileId, "------push fileId");
        this.accountResumeData.interviewImageFileIds.push(fileId);
      } else {
        // this.accountResumeData[field] = fileId;
        // this.accountResumeData[name] = fileUrl;
        this.$set(this.accountResumeData, field, fileId);
        this.$set(this.accountResumeData, name, fileUrl);
      }
      // return (response, file, fileList) => {
      //   if (response.result.isSuccess) {
      //     this.accountResumeData[field] =
      //       response.data.fileId + "." + response.data.ext;
      //     this.accountResumeData[name] =
      //       this.$linkUrl + response.data.fileId + "." + response.data.ext;
      //     this.uploadDisabled = true;
      //   }
      // };
    },
    // 校验证件号码
    // validateID(row) {
    //   let value = row.relativesIdNo;
    //   let type = row.relativesIdType;
    //   row.errorMessage = "";
    //   // 1️⃣ 身份证 / 户口本（18位，最后一位X需大写）
    //   if (type === "01") {
    //     if (!/^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$|^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}([0-9]|X)$/.test(value)) {
    //       row.errorMessage = ERR.IE1004;
    //       return false;
    //     }
    //   }

    //   // 2️⃣ 护照（至少3位，字母需大写）
    //   else if (type === "51") {
    //     if (value.length < 3) {
    //       row.errorMessage = "护照号码至少3个字符";
    //       return false;
    //     }
    //     if (/[a-z]/.test(value)) {
    //       row.errorMessage = "护照号码中的字母应为大写";
    //       return false;
    //     }
    //   }

    //   // 3️⃣ 台湾居民来往大陆通行证（不少于8个字符）
    //   else if (type === "02") {
    //     if (value.length < 8) {
    //       row.errorMessage = "台湾居民来往大陆通行证的号码位数不少于8个字符";
    //       return false;
    //     }
    //   }

    //   // 4️⃣ 港澳居民来往内地通行证（11位，首位为H或M）
    //   else if (type === "09") {
    //     if (!/^[HM]\d{10}$/.test(value)) {
    //       row.errorMessage = "港澳居民来往内地通行证共11位,首位只能为H或M";
    //       return false;
    //     }
    //   }

    //   // 5️⃣ 台湾居民居住证（前4位8300，最长不超过25位）
    //   else if (type === "04") {
    //     if (!value.startsWith("8300")) {
    //       row.errorMessage = "台湾居民居住证前4位应为8300";
    //       return false;
    //     }
    //     if (value.length > 25) {
    //       row.errorMessage = "台湾居民居住证号码不能超过25位";
    //       return false;
    //     }
    //   }

    //   return true;
    // },
    backFunc() {
      this.$emit("back");
    },
    validateTable(refName) {
      let flag = false;
      this.$refs[refName].validate((valid) => {
        if (!valid) flag = false;
        else {
          flag = true;
        }
      });
      return flag;
    },
    validateWorkRow(row, index) {
      let rowErrors = {};
      if (!row.unit) {
        rowErrors.unit = "工作单位/学校不能为空";
      } else if (!ValidateUtility.placename(row.unit).istrue) {
        rowErrors.unit = "工作单位/学校" + ERR.IE1003;
      }

      if (!ValidateUtility.placename(row.dept).istrue) {
        rowErrors.dept = "部门" + ERR.IE1003;
      }

      if (!ValidateUtility.placename(row.job).istrue) {
        rowErrors.job = "职位" + ERR.IE1003;
      }

      if (!ValidateUtility.placename(row.transReason).istrue) {
        rowErrors.transReason = "调动理由" + ERR.IE1003;
      }

      if (!ValidateUtility.placename(row.reterence).istrue) {
        rowErrors.reterence = "证明人" + ERR.IE1003;
      }

      // if (!ValidateUtility.mobilephone(row.tel).istrue) {
      //   rowErrors.tel = "证明电话" + ERR.IE1002;
      // }
      this.errorsWork[index] = rowErrors;
      return Object.keys(rowErrors).length === 0;
    },
    validateEducationRow(row, index) {
      let rowErrors = {};
      if (!row.school) {
        rowErrors.school = "学校不能为空";
      } else if (!ValidateUtility.placename(row.school).istrue) {
        rowErrors.school = "学校" + ERR.IE1003;
      }

      if (!ValidateUtility.placename(row.specialty).istrue) {
        rowErrors.specialty = "专业" + ERR.IE1003;
      }

      if (!ValidateUtility.placename(row.series).istrue) {
        rowErrors.series = "系" + ERR.IE1003;
      }

      if (!ValidateUtility.placename(row.specialtyBackground).istrue) {
        rowErrors.specialtyBackground = "专业背景" + ERR.IE1003;
      }

      this.errorsEducation[index] = rowErrors;
      return Object.keys(rowErrors).length === 0;
    },
    validateFamilyRow(row, index) {
      let rowErrors = {};
      if (!row.name) {
        rowErrors.name = "姓名不能为空";
      } else if (!ValidateUtility.placename(row.name).istrue) {
        rowErrors.name = "姓名" + ERR.IE1003;
      }

      if (!ValidateUtility.placename(row.unit).istrue) {
        rowErrors.unit = "工作单位/学校" + ERR.IE1003;
      }

      if (!ValidateUtility.placename(row.profession).istrue) {
        rowErrors.profession = "职位" + ERR.IE1003;
      }

      if (!row.relativesIdType) {
        rowErrors.relativesIdType = "证件类型不能为空";
      }

      if (!row.relativesIdNo) {
        rowErrors.profession = "证件号码不能为空";
      } else {
        let msg = this.checkCard(row.relativesIdType, row.relativesIdNo);
        if (msg) {
          rowErrors.relativesIdNo = msg;
        }
      }
      if (!row.relativesSex) {
        rowErrors.relativesSex = "性别不能为空";
      }

      this.errorsFamily[index] = rowErrors;
      return Object.keys(rowErrors).length === 0;
    },
    checkCard(cardType, cardNumber) {
      let str4 = cardNumber.slice(0, 4);
      if (cardType === "10") {
        if (str4 != "8100" && str4 != "8200") {
          return ERR.IE1024;
        }
      }
      if (cardType === "11") {
        if (str4 != "8300") {
          return ERR.IE1025;
        }
      }
      if (
        cardType === "1" ||
        cardType === "7" ||
        cardType === "10" ||
        cardType === "11"
      ) {
        const res = ValidateUtility.card(cardNumber); // ValidateUtility.card中已验证-证件号中的字母必须为大写
        if (!res.istrue) {
          return ERR.IE1004;
        }
        const reg =
          /^[1-9][0-7]\d{4}((([0-9]{3}[1-9]|[0-9]{2}[1-9][0-9]{1}|[0-9]{1}[1-9][0-9]{2}|[1-9][0-9]{3})(((0[13578]|1[02])(0[1-9]|[12][0-9]|3[01]))|((0[469]|11)(0[1-9]|[12][0-9]|30))|(02(0[1-9]|[1][0-9]|2[0-8]))))|((([0-9]{2})(0[48]|[2468][048]|[13579][26])|((0[48]|[2468][048]|[3579][26])00))0229))\d{3}(\d|X|x)?$/;
        switch (cardNumber.length) {
          case 18:
            if (reg.test(cardNumber)) {
              const S =
                (parseInt(cardNumber[0]) + parseInt(cardNumber[10])) * 7 +
                (parseInt(cardNumber[1]) + parseInt(cardNumber[11])) * 9 +
                (parseInt(cardNumber[2]) + parseInt(cardNumber[12])) * 10 +
                (parseInt(cardNumber[3]) + parseInt(cardNumber[13])) * 5 +
                (parseInt(cardNumber[4]) + parseInt(cardNumber[14])) * 8 +
                (parseInt(cardNumber[5]) + parseInt(cardNumber[15])) * 4 +
                (parseInt(cardNumber[6]) + parseInt(cardNumber[16])) * 2 +
                parseInt(cardNumber[7]) * 1 +
                parseInt(cardNumber[8]) * 6 +
                parseInt(cardNumber[9]) * 3;
              const Y = S % 11;
              let M = "F";
              const JYM = "10X98765432";
              M = JYM.substr(Y, 1);
              if (M !== cardNumber[17].toUpperCase()) {
                return ERR.IE1020;
              }
            }
        }
      }
      if (cardType === "8") {
        if (!/^[A-Z]/.test(cardNumber.substr(0, 1))) {
          return ERR.IE1017; // IE1017: '出生证的证件号首字母必须为大写',
        }
      }
      /**
       * 证件类型为护照，则：护照号码位数不能低于3个字符。护照号码中如包含字母，则字母应为大写
       */
      if (cardType === "2") {
        const reg_passport = /^([A-Z]|[0-9]){3,25}$/; // 护照
        if (cardNumber.length < 3) {
          return ERR.IE1019; // IE1019: '证件类型为护照，护照号码位数不能低于3个字符',
        }
        if (!reg_passport.test(cardNumber)) {
          return ERR.IE1020; // IE1020: '请您输入有效的证件号码'
        }
      }
      /**
       * 证件类型为台湾居民来往大陆通行证，则：台湾居民来往大陆通行证的号码位数不少于8个字符。
       * 如有字母应大写
       */
      if (cardType === "6") {
        if (cardNumber.length < 8) {
          return ERR.IE1020;
        }
        const reg_passport = /^([A-Z]|[0-9]){8,}$/;
        if (!reg_passport.test(cardNumber)) {
          return ERR.IE1020;
        }
      }
      /**
       * 证件类型为港澳居民往来内地通行证，则: 港澳居民往来内地通行证号码组成规则：通行证证件号码共9位,首位只能为H或M
       */
      if (cardType === "5") {
        if (
          cardNumber.length !== 9 ||
          (cardNumber[0] !== "H" && cardNumber[0] !== "M")
        ) {
          return ERR.IE1020;
        } else {
          const reg = /^[0-9]*$/g;
          if (!reg.test(cardNumber.substring(1))) {
            return ERR.IE1020;
          }
        }
      }
      /**
       * 若证件类型为军官证、士兵证，则：
          a)军官证、士兵证号码位数，不能为9位以下或18位以上，号码信息必须包含汉字。包含汉字9<=N<=18,且一个汉字占一位。
          b)军官证只能录入：汉字+数字
      */
      if (cardType === "3" || cardType === "4") {
        if (cardNumber.length < 9 || cardNumber.length > 18) {
          return ERR.IE1020;
        } else {
          const rega = /[\u4E00-\u9FA5]/g;
          if (!rega.test(cardNumber)) {
            return ERR.IE1020;
          }
        }
      }
      /** 证件类型非身份证、非户口本的证件类型、非港澳居民居住证、台湾居民居住证，不允许证件号码仍为15位或18位，不应符合身份证号相关的校验规则 */
      if (
        !(
          cardType === "1" ||
          cardType === "7" ||
          cardType === "10" ||
          cardType === "11"
        )
      ) {
        if (cardNumber.length == 15 || cardNumber.length == 18) {
          return ERR.IE1026;
        }
      }
      // if (cardType === "01") {
      //   const res = ValidateUtility.card(cardNumber);
      //   if (!res.istrue) {
      //     return ERR.IE1004;
      //   }
      // } else if (cardType === "09") {
      //   if (!this.mainlandTravelCard(cardNumber)) {
      //     return ERR.IE1004;
      //   }
      // } else if (cardType === "51") {
      //   if (!this.passport(cardNumber)) {
      //     return ERR.IE1004;
      //   }
      //   if (cardNumber.length < 3 || cardNumber.length > 25) {
      //     return ERR.IE1012;
      //   }
      // } else if (cardType === "02") {
      //   // 台湾居民来往大陆通行证
      //   /**
      //    * 证件类型为台湾居民来往大陆通行证，则：台湾居民来往大陆通行证的号码位数不少于8个字符。
      //    * 如有字母应大写
      //    */
      //   if (cardNumber.length < 8) {
      //     return ERR.IE1020;
      //   }
      //   const reg_passport = /^([A-Z]|[0-9]){8,}$/;
      //   if (!reg_passport.test(cardNumber)) {
      //     return ERR.IE1020;
      //   }
      // } else if (cardType === "03") {
      //   // 港澳居民居住证03
      //   /** 港澳居民居住证的证件号前4位应为8100或8200 ----  810000199408230021 */
      //   let str4 = cardNumber.slice(0, 4);
      //   console.log(str4, "==前四位==");
      //   if (str4 != "8100" && str4 != "8200") {
      //     return ERR.IE1024;
      //   }
      //   this.validateCardType(cardNumber);
      // } else if (cardType === "04") {
      //   // 台湾居民居住证04
      //   /** 台湾居民居住证的证件号前4位应为8300 */
      //   let str4 = cardNumber.slice(0, 4);
      //   console.log(str4, "==前四位==");
      //   if (str4 != "8300") {
      //     return ERR.IE1025;
      //   }
      //   this.validateCardType(cardNumber);
      // }
      // /** 证件类型非身份证、非户口本的证件类型、非港澳居民居住证、台湾居民居住证，不允许证件号码仍为15位或18位，不应符合身份证号相关的校验规则 */
      // if (!(cardType === "01" || cardType === "03" || cardType === "04")) {
      //   if (cardNumber.length == 15 || cardNumber.length == 18) {
      //     return ERR.IE1026;
      //   }
      // }
    },
    validateCardType(cardNumber) {
      const res = ValidateUtility.card(cardNumber); // ValidateUtility.card中已验证-证件号中的字母必须为大写
      if (!res.istrue) {
        return ERR.IE1004;
      }
      const reg =
        /^[1-9][0-7]\d{4}((([0-9]{3}[1-9]|[0-9]{2}[1-9][0-9]{1}|[0-9]{1}[1-9][0-9]{2}|[1-9][0-9]{3})(((0[13578]|1[02])(0[1-9]|[12][0-9]|3[01]))|((0[469]|11)(0[1-9]|[12][0-9]|30))|(02(0[1-9]|[1][0-9]|2[0-8]))))|((([0-9]{2})(0[48]|[2468][048]|[13579][26])|((0[48]|[2468][048]|[3579][26])00))0229))\d{3}(\d|X|x)?$/;
      switch (cardNumber.length) {
        case 18:
          if (reg.test(cardNumber)) {
            const S =
              (parseInt(cardNumber[0]) + parseInt(cardNumber[10])) * 7 +
              (parseInt(cardNumber[1]) + parseInt(cardNumber[11])) * 9 +
              (parseInt(cardNumber[2]) + parseInt(cardNumber[12])) * 10 +
              (parseInt(cardNumber[3]) + parseInt(cardNumber[13])) * 5 +
              (parseInt(cardNumber[4]) + parseInt(cardNumber[14])) * 8 +
              (parseInt(cardNumber[5]) + parseInt(cardNumber[15])) * 4 +
              (parseInt(cardNumber[6]) + parseInt(cardNumber[16])) * 2 +
              parseInt(cardNumber[7]) * 1 +
              parseInt(cardNumber[8]) * 6 +
              parseInt(cardNumber[9]) * 3;
            const Y = S % 11;
            let M = "F";
            const JYM = "10X98765432";
            M = JYM.substr(Y, 1);
            if (M !== cardNumber[17].toUpperCase()) {
              return ERR.IE1020;
            }
          }
      }
    },
    mainlandTravelCard(cardNumber) {
      let res = true;
      if (
        cardNumber.length !== 9 ||
        (cardNumber[0] !== "H" && cardNumber[0] !== "M")
      ) {
        res = false;
        return res;
      } else {
        const reg = /^[0-9]*$/g;
        if (!reg.test(cardNumber.substring(1))) {
          res = false;
          return res;
        }
      }
      return res;
    },
    passport(cardNumber) {
      let res = true;
      let reg = /^([A-Z]|[0-9]){3,25}$/;
      if (cardNumber.length < 3) {
        res = false;
        return res;
      }
      if (!reg.test(cardNumber)) {
        res = false;
        return res;
      }
      return res;
    },
    saveFunc() {
      console.log("保存", this.$refs.baseFormRef);
      console.log("保存 ------------》", this.accountResumeData.accountOther)
      this.$refs["baseFormRef"].validate((valid) => {
        console.log(valid, "valid");
        if (valid) {
          console.log(valid, "valid");
          this.validateDetail();
        } else {
          return false;
        }
      });
    },
    validateDetail() {
      console.log("进入表格校验");

      let hasWorkError = false;
      if (this.accountResumeData.works.length) {
        this.errorsWork = this.accountResumeData.works.map((row, index) => {
          const isValid = this.validateWorkRow(row, index);
          if (!isValid) {
            hasWorkError = true;
          }
          return this.errorsWork[index];
        });
      }

      let hasEducationError = false;
      if (this.accountResumeData.educations) {
        this.errorsEducation = this.accountResumeData.educations.map(
          (row, index) => {
            const isValid = this.validateEducationRow(row, index);
            if (!isValid) {
              hasEducationError = true;
            }
            return this.errorsEducation[index];
          }
        );
      }

      let hasFamilyError = false;
      if (this.accountResumeData.families.length) {
        this.errorsFamily = this.accountResumeData.families.map(
          (row, index) => {
            const isValid = this.validateFamilyRow(row, index);
            if (!isValid) {
              hasFamilyError = true;
            }
            return this.errorsFamily[index];
          }
        );
      }

      if (!hasWorkError && !hasEducationError && !hasFamilyError) {
        // 验证其他信息
        if (
          this.accountResumeData.accountOther.ques2 == "1" &&
          !this.accountResumeData.accountOther.ques2Desc
        ) {
          this.$message({
            type: "error",
            message: "请填写是否从事过人寿保险相关工作的简要说明",
          });
          return false;
        }
        this.$refs.uploadForm.validate((valid) => {
          if (valid) {
            const saveData = this.getSaveData(this.accountResumeData);
            console.log(saveData, "saveData===============");
            api.post(url.updateAccountInfo, saveData, (res) => {
              if (res.result.isSuccess) {
                this.getDetail();
                console.log(res.data, "updateAccountInfo===============");
                this.$message({
                  type: "success",
                  message: "保存成功",
                });
              } else {
                this.$message({
                  type: "error",
                  message: res.result.error,
                });
              }
            });
          } else {
            return false;
          }
        });
      } else {
        let errorsWorkInfo = "工作经历：" + this.formatErrors(this.errorsWork);
        let errorsEducationInfo =
          "学习经历：" + this.formatErrors(this.errorsEducation);
        let errorsFamilyInfo =
          "家庭成员：" + this.formatErrors(this.errorsFamily);
        if (errorsWorkInfo.length > 12) {
          this.$message.error(errorsWorkInfo);
          return;
        }
        if (errorsEducationInfo.length > 12) {
          this.$message.error(errorsEducationInfo);
          return;
        }
        console.log(this.errorsFamily, "errorsFamily------->");
        console.log(errorsFamilyInfo, "errorsFamilyInfo------->");
        if (errorsFamilyInfo.length > 12) {
          this.$message.error(errorsFamilyInfo);
          return;
        }
      }
    },
    getSaveData(data) {
      const {
        nativePlace,
        permanentResidence,
        liveGrounds,
        familyAdress,
        accountOther,
      } = data;
      data.originProvince = nativePlace[0];
      data.originCity = nativePlace[1];
      data.originArea = nativePlace[2];
      data.residenceProvince = permanentResidence[0];
      data.residenceCity = permanentResidence[1];
      data.residenceArea = permanentResidence[2];
      data.liveProvince = liveGrounds[0];
      data.liveCity = liveGrounds[1];
      data.liveArea = liveGrounds[2];
      data.familyProvince = familyAdress[0];
      data.familyCity = familyAdress[1];
      data.familyArea = familyAdress[2];
      for (let key in accountOther) {
        if (key.startsWith("ques")) {
          if (key == 'ques2') {
            if (accountOther[key] && accountOther[key] != "0") {
              this.$set(data.accountOther, "ques2", data.accountOther.ques2Desc ? data.accountOther.ques2Desc : "是");
            } else {
              this.$set(data.accountOther, "ques2", "否");
            }
          } else {
            if (accountOther[key] == "1") {
              this.$set(data.accountOther, key, "是");
            } else {              
              this.$set(data.accountOther, key, "否");
            }
          }
        }
      }
      
      if (data.educations) {
        data.educations.map((ele, index) => {
          let dates = ele.beginDate.split("-");
          if (dates.length == 2) {
            ele.beginDate = ele.beginDate ? `${ele.beginDate}-01` : '';
          }
          dates = ele.endDate.split("-");
          if (dates.length == 2) {
            ele.endDate = ele.endDate ? `${ele.endDate}-01` : '';
          }
          
        });
      }
      if (data.works) {
        data.works.map((ele, index) => {
          let dates = ele.beginDate.split("-");
          if (dates.length == 2) {
            ele.beginDate = ele.beginDate ? `${ele.beginDate}-01` : '';
          }
          dates = ele.endDate.split("-");
          if (dates.length == 2) {
            ele.endDate = ele.endDate ? `${ele.endDate}-01` : '';
          }
        });
      }
      return data;
    },
    formatErrors(errors) {
      return errors
        .map((error, index) => {
          // 判断对象是否为空
          if (Object.keys(error).length === 0) {
            return null; // 空对象不输出
          }
          const messages = Object.entries(error)
            .map(([key, value]) => `${value}`)
            .join("，");
          return `第 ${index + 1} 行：${messages}`;
        })
        .filter(Boolean)
        .join("；"); // 过滤掉空对象的行
    },
    setDetailDataInPage(data) {
      const {
        accountOther,
        originProvince,
        originCity,
        originArea,
        residenceProvince,
        residenceCity,
        residenceArea,
        liveProvince,
        liveCity,
        liveArea,
        familyProvince,
        familyCity,
        familyArea,
        certificateFrontPhotoFileId,
        certificateBackPhotoFileId,
        educationPhotoFileId,
        degreePhotoFileId,
        interviewImageFileIds,
      } = data;
      // if (accountOther.ques2 != "0" && accountOther.ques2 != "否") {
      //   this.$set(data.accountOther, "ques2Desc", accountOther.ques2);
      //   this.$set(data.accountOther, "ques2", "1");
      // }
      this.$set(data, "nativePlace", [originProvince, originCity, originArea]);
      this.$set(data, "permanentResidence", [
        residenceProvince,
        residenceCity,
        residenceArea,
      ]);
      this.$set(data, "liveGrounds", [liveProvince, liveCity, liveArea]);
      this.$set(data, "familyAdress", [familyProvince, familyCity, familyArea]);
      // 影像特殊处理
      if (interviewImageFileIds && interviewImageFileIds.length) {
        this.fileListInterview = interviewImageFileIds.map((item) => ({
          url: item.indexOf(this.$linkUrl) !== -1 ? item : this.$linkUrl + item,
          name: item,
        }));
        console.log(this.fileListInterview, "--------fileListInterview");
      } else {
        this.fileListInterview = [];
      }
      this.accountResumeData = {
        idPhotoFront: certificateFrontPhotoFileId
          ? this.$linkUrl + certificateFrontPhotoFileId
          : "",
        idPhotoBack: certificateBackPhotoFileId
          ? this.$linkUrl + certificateBackPhotoFileId
          : "",
        educationPhotoUrl: educationPhotoFileId
          ? this.$linkUrl + educationPhotoFileId
          : "",
        degreePhotoUrl: degreePhotoFileId
          ? this.$linkUrl + degreePhotoFileId
          : "",
        ...data,
      };
      if (data.educations) {
        data.educations.map((ele, index) => {
          ele.beginDate = ele.beginDate.substring(0, 7);
          ele.endDate = ele.endDate.substring(0, 7);
        });
      }
      if (data.works) {
        data.works.map((ele, index) => {
          data.works.map((ele, index) => {
            ele.beginDate = ele.beginDate.substring(0, 7);
            ele.endDate = ele.endDate.substring(0, 7);
          });
        });
      }
      console.log(this.accountResumeData, "-----------图片信息");
      // if (data.interviewImageFileIds && data.interviewImageFileIds.length > 0) {
      //   data.interviewImageFileIds.forEach(
      //     interviewImageFileId => {
      //       accountResumeData.interviewImageFileIds.push(this.$linkUrl + interviewImageFileId);
      //   })
      // }
    },
  },
  mounted() {
    this.fileUrl = this.$uploadImg;
    this.notEditable = this.states == "edit" ? false : true;
    this.getDetail();
    if (this.tab === 2) {
      this.getProcessList();
    }
  },
};
</script>
<style lang="scss" scoped>
.detail-content {
  h3 {
    border-left: 8px solid #4a6bbe;
    border-radius: 3px 0 0 3px;
    padding-left: 5px;
  }
  padding: 0 20px;
  height: calc(100vh - 100px);
  overflow-y: auto;
}
.backBtn {
  position: absolute;
  top: 16px;
  right: 20px;
}
.process-record {
  padding: 0;
  margin: 0;
  li {
    list-style: none;
  }
}
.work-history {
  .table-form .el-form-item {
    // margin-bottom: 0;
  }
}
.office-saff-table {
  border: 1px solid #ebeef5;
  padding: 0 10px;
  margin: 20px 0;
  .work-history-btn,
  .learning-experience-btn,
  .family-members-btn {
    padding: 10px;
    text-align: right;
  }
}
.other-info {
  padding: 0 30px;
}
.upload-form {
  padding: 0 30px;
  .preview-container {
    display: flex;
    gap: 10px;
    flex-wrap: wrap;
  }
  .preview-image {
    width: 100px;
    height: 100px;
    object-fit: cover;
    cursor: pointer;
    border-radius: 5px;
    border: 1px solid #ddd;
  }
  .preview-video {
    width: 200px;
    border-radius: 5px;
    border: 1px solid #ddd;
  }
}
.error-text {
  color: red;
  font-size: 12px;
  margin-top: 4px;
}
</style>
<style>
.float-btn {
  position: fixed;
  right: 30px;
  bottom: 30px;
  width: 60px;
  height: 60px;
  background: #2196F3;
  color: white;
  border-radius: 50%;
  text-align: center;
  box-shadow: 0 4px 8px rgba(0,0,0,0.2);
  cursor: pointer;
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  transition: all 0.3s;
}
.float-btn:hover {
  background: #0b7dda;
  transform: scale(1.1);
}
.office-saff-table .el-table--border::after,
.office-saff-table .el-table--group::after,
.office-saff-table .el-table::before {
  /* background: #ffffff; */
}
.office-saff-table .el-table td.el-table__cell,
.office-saff-table .el-table th.el-table__cell.is-leaf {
  /* border: none; */
}
.basic-info .el-row.first-row {
  display: flex;
  align-items: center;
}
.el-form-item__label {
  padding: 0;
}
.el-input.is-disabled .el-input__inner {
  color: #4c5158;
}
.el-form--inline .el-form-item {
  margin-right: 20px;
}
.el-form-item--mini.el-form-item,
.el-form-item--small.el-form-item {
  margin-bottom: 10px;
}
.input-width200 .el-input {
  width: 200px;
}
.error-tips .el-form-item__error {
  left: 12px;
}
.basic-info .el-descriptions-item__container {
  display: flex;
  align-items: center;
}
.basic-info .el-descriptions-item {
  display: table-cell;
  vertical-align: middle;
}
.custom-timeline-item .el-timeline-item__tail {
  border-color: #409eff;
}
.interview-comment-label {
  background-color: #409EFF;
  border-radius: 4px;
  padding: 2px 6px;
  color: white;
}
</style>



// WEBPACK FOOTER //
// src/pages/recruit/officeSaff/detail.vue